import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getRecentVacanciesRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/recent-vacancies");

  return response.data;
};
